const colors ={
    yellow: '#f8aa00',
    purple: '#662383'
};

export default colors;